import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SideBySideSection = ({ section }) => {
  const isImageLeft = section.imagePosition === "left";

  return (
    <div className="flex flex-col lg:flex-row h-auto lg:h-screen mb-8 lg:mb-0">
      {isImageLeft && (
        <div className="w-full lg:w-1/2 h-64 lg:h-full">
          <img
            src={section.image.src}
            alt={section.image.alt}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="w-full lg:w-1/2 h-auto lg:h-full flex items-center justify-center p-6 lg:p-12">
        <div>
          <h2 className="text-2xl lg:text-4xl font-bold mb-4 lg:mb-6">
            {section.title}
          </h2>
          <p className="text-base lg:text-lg leading-relaxed text-gray-700">
            {section.content}
          </p>
        </div>
      </div>
      {!isImageLeft && (
        <div className="w-full lg:w-1/2 h-64 lg:h-full">
          <img
            src={section.image.src}
            alt={section.image.alt}
            className="w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};

const FullPageSections = () => {
  const { t } = useTranslation("fullpagesection");

  const sectionData = t("sections", { returnObjects: true });

  const sectionsWithImages = [
    {
      ...sectionData[0],
      image: { src: "/assets/images/img_06.jpg", alt: "Setting and Polishing" },
      imagePosition: "left",
    },
    {
      ...sectionData[1],
      image: { src: "/assets/images/img_07.jpg", alt: "Crafting and Finishing" },
      imagePosition: "right",
    },
    {
      ...sectionData[0],
      image: { src: "/assets/images/img_08.jpg", alt: "Setting and Polishing" },
      imagePosition: "left",
    },
    {
      ...sectionData[1],
      image: { src: "/assets/images/img_09.jpg", alt: "Crafting and Finishing" },
      imagePosition: "right",
    },
  ];

  return (
    <>
      <Helmet>
        <title>What We Do | Wellstar Jewels</title>
        <meta
          name="description"
          content="Polishing, Cutting, Customization all we can do."
        />
      </Helmet>
      <div>
        {sectionsWithImages.map((section, index) => (
          <SideBySideSection key={index} section={section} />
        ))}
      </div>
    </>
  );
};

export default FullPageSections;
